/**
 * Formats a value as currency using USD
 * @param value The number to format
 * @param fractionDigits Optional min/max fraction digits (default 2)
 * @returns Formatted currency string
 */
export function formatCurrency(value: number | undefined, minFractionDigits = 2, maxFractionDigits = 2): string {
  if (value === undefined || value === null) return ''

  return value.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: minFractionDigits,
    maximumFractionDigits: maxFractionDigits,
  })
}

/**
 * Formats a value with commas but no currency
 * @param value The number to format
 * @param fractionDigits Optional fraction digits (default 2)
 * @returns Formatted number string
 */
export function formatNumber(value: number | undefined, fractionDigits = 2): string {
  if (value === undefined || value === null) return ''

  return value.toLocaleString('en-US', {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  })
}

/**
 * Formats a value with unit of measure
 * @param value The number to format
 * @param uom Unit of measure to append
 * @param fractionDigits Optional fraction digits (default 2)
 * @returns Formatted number with UOM
 */
export function formatWithUOM(value: number | undefined, uom: string | undefined, fractionDigits = 2): string {
  if (value === undefined || value === null) return ''

  const formattedValue =
    fractionDigits === 0 ? Math.round(value).toLocaleString('en-US') : value.toFixed(fractionDigits).toLocaleString()

  return `${formattedValue} ${uom || ''}`.trim()
}
